module.exports = __webpack_public_path__ + "img/geniuz.fa9be60e.png";